import React, { useEffect, useState } from 'react';
import axios from 'axios';
import sendLogout from './Logout';
import baseTheme from '@vkontakte/vkui-tokens/themes/vkBase';
import { Config, Connect, ConnectEvents } from '@vkontakte/superappkit';
import { FaTelegram } from "react-icons/fa6";
import Cookies from 'js-cookie';
import ChannelPage from './pages/ChannelPage';
import TeamPage from './pages/TeamPage';
import TestDrivePage from './pages/TestDrivePage';
import PromptsPage from './pages/PromptsPage';
import StreamsPage from './pages/StreamsPage';
import RssPage from './pages/RssPage';
import DigestPage from './pages/DigestPage';
import SourcesPage from './pages/SourcesPage';
import ChannelPageTest from './pages/ChannelPageTest';
import OnboardingPage from './pages/OnboardingPage';
import OnboardingAddPage from './pages/OnboardingAddPage';
import PremodePage from './pages/PremodePage';
import TopicsPage from './pages/TopicsPage';
import PayPage from './pages/PayPage';
import PostPage from './pages/PostPage';
import PushPage from './pages/PushPage';
import PostingPage from './pages/PostingPage';
import TimersPage from './pages/TimersPage';
import FilterPage from './pages/FilterPage';
import StylePage from './pages/StylePage';
import OtherPage from './pages/OtherPage';
import SourcesLibPage from './pages/SourcesLibPage';
import Push from './Push';
import TestGPT from './TestGPT';

// Lottie
import Lottie from 'react-lottie';
import noChannels from './lotties/thinking_face.json';
import smile from './lotties/smile.json';

// Import the necessary styles globally
import '@telegram-apps/telegram-ui/dist/styles.css';

// Import components from the library
import { AppRoot, Cell as CellTG, List, Section, Modal, Badge } from '@telegram-apps/telegram-ui';

import { ReactComponent as TelegramIcon } from './assets/social/telegram.svg';
import { ReactComponent as VkIcon } from './assets/social/vk.svg';
import { ReactComponent as DzenIcon } from './assets/social/dzen.svg';
import { ReactComponent as InstagramIcon } from './assets/social/instagram.svg';
import { ReactComponent as FacebookIcon } from './assets/social/facebook.svg';
import { ReactComponent as XIcon } from './assets/social/x.svg';
import { ReactComponent as OdnoklassnikiIcon } from './assets/social/odnoklassniki.svg';
import { ReactComponent as MaxIcon } from './assets/social/max.svg';
import { ReactComponent as RSSIcon } from './assets/social/rss.svg';

import { Avatar, Banner, Button, FormItem, FormStatus, FormLayout, Group, Input, ModalRoot, ModalCard, Panel, Header as Head, PanelHeader, PanelHeaderBack, Platform, Root, Snackbar, Spinner, unstable_Popover as Popover, usePlatform, View, SegmentedControl, Div, Card, Separator, Spacing, CardGrid, Text } from '@vkontakte/vkui';
import { Icon24List, Icon16DownloadOutline, Icon20AddCircleOutline, Icon24Back, Icon16GridOfFour, Icon24Add, Icon24CircleSmall, Icon24DoorArrowRightOutline, Icon28ErrorCircleOutline, Icon56ChainOutline, Icon20MoneyCircleOutline, Icon20HelpOutline, Icon16ClockOutline, Icon20ViewOutline, Icon20HideOutline } from '@vkontakte/icons';

Config.init({
    appId: 51784114,

    appSettings: {
        agreements: '',
        promo: '',
        vkc_behavior: '',
        vkc_auth_action: '',
        vkc_brand: '',
        vkc_display_mode: '',
    },
});

const sendEventToFlask = (event) => {
    const payload = {
        ...event.payload,
        tg_id: tg.initDataUnsafe.user.id
    };

    axios.post('https://api.gmpapp.ru/gmp_auth', payload)
        .then((response) => {
            window.location.reload();
        })
        .catch((error) => {
            console.error('Ошибка при отправке события в Flask:', error);
            window.location.reload();
        });
};

const okAuth = () => {
    tg.showPopup({
        title: "Одноклассники",
        message: "Вы будете перенаправлены на страницу авторизации на сайт «Одноклассники». После авторизации проставьте все чекбоксы и нажмите «Разрешить», чтобы ваши группы были доступны в GiveMePublic",
        buttons: [
            { id: 'ok', text: 'Перейти' },
            { id: 'cancel', type: 'cancel' },
        ]
    }, (buttonId) => {
        if (buttonId === 'cancel') {
            console.log("Действие отменено");
        } else if (buttonId === 'ok') {
            const authUrl = `https://connect.ok.ru/oauth/authorize?client_id=512004974397&redirect_uri=https://api.gmpapp.ru/okauth&scope=LONG_ACCESS_TOKEN%3BVALUABLE_ACCESS%3BPUBLISH_TO_STREAM%3BGROUP_CONTENT%3BPHOTO_CONTENT%3BMESSAGING%3BVIDEO_CONTENT%3BPUBLISH_NOTE%3BSET_STATUS&response_type=code&state=${tg.initDataUnsafe.user.id}`;

            window.location.href = authUrl;
        }
    });
};

const communityLink = () => {
    tg.showPopup({
        title: "Выход из сервиса",
        message: "Вы покидаете сервис и переходите в Telegram-чат коммьюнити GiveMePublic. Там можно задать любой вопрос по настройкам и/или по работе. Перейти в чат?",
        buttons: [
            { id: 'ok', text: 'Перейти' },
            { id: 'cancel', type: 'cancel' },
        ]
    }, (buttonId) => {
        if (buttonId === 'cancel') {
            console.log("Действие отменено");
        } else if (buttonId === 'ok') {
            tg.openTelegramLink('https://t.me/ask4gmp');
            tg.close();
        }
    });
};

const oneTapButton = Connect.buttonOneTapAuth({
    callback: (event) => {
        const { type } = event;

        if (!type) {
            return;
        }
        // eslint-disable-next-line
        switch (type) {
            case ConnectEvents.OneTapAuthEventsSDK.LOGIN_SUCCESS: // = 'VKSDKOneTapAuthLoginSuccess'
                sendEventToFlask(event);
                return;
            // Для этих событий нужно открыть полноценный VK ID чтобы
            // пользователь дорегистрировался или подтвердил телефон
            case ConnectEvents.OneTapAuthEventsSDK.FULL_AUTH_NEEDED: //  = 'VKSDKOneTapAuthFullAuthNeeded'
            case ConnectEvents.OneTapAuthEventsSDK.PHONE_VALIDATION_NEEDED: // = 'VKSDKOneTapAuthPhoneValidationNeeded'
            case ConnectEvents.ButtonOneTapAuthEventsSDK.SHOW_LOGIN: // = 'VKSDKButtonOneTapAuthShowLogin'
                // url - строка с url, на который будет роизведён редирект после авторизации.
                // state - состояние вашего приложение или любая произвольная строка, которая будет добавлена к url после авторизации.
                return Connect.redirectAuth({ url: 'https://gmpapp.ru/', state: '' })
            // Пользователь перешел по кнопке "Войти другим способом"
            case ConnectEvents.ButtonOneTapAuthEventsSDK.SHOW_LOGIN_OPTIONS: // = 'VKSDKButtonOneTapAuthShowLoginOptions'
            //     // Параметр screen: phone позволяет сразу открыть окно ввода телефона в VK ID
            //     // Параметр url: ссылка для перехода после авторизации. Должен иметь https схему. Обязательный параметр.
            //     return Connect.redirectAuth({ screen: 'phone', url: 'https://gmpapp.ru' });
        }
        return;
    },
    // Не обязательный параметр с настройками отображения OneTap
    options: {
        showAlternativeLogin: false,
        showAgreements: true,
        displayMode: 'default',
        langId: 0,
        buttonSkin: 'primary',
        buttonStyles: {
            borderRadius: 8,
            height: 50,
        },
    },
});

const tg = window.Telegram.WebApp;

const urlParams = new URLSearchParams(window.location.search);
const successParam = urlParams.get('Success');
const OrderId = urlParams.get('OrderId');

if (successParam && successParam.toLowerCase() === 'true') {
    const tg = window.Telegram.WebApp;
    tg.showAlert('Подписка успешно оплачена!');
} else if (successParam && successParam.toLowerCase() === 'false') {
    const tg = window.Telegram.WebApp;
    tg.showAlert('Что-то пошло не так. Проверьте вашу карту и попробуйте снова');
}

const Home = ({ isMobile }) => {
    const [isLoadingChannels, setIsLoadingChannels] = useState(true);
    const [isLoadingGroups, setIsLoadingGroups] = useState(true);
    const [isLoadingOkGroups, setIsLoadingOkGroups] = useState(true);
    const [isMaxError, setIsMaxError] = useState(false);
    const [maxErrorTitle, setMaxErrorTitle] = useState("Не удалось найти канал");
    const [maxErrorDesc, setMaxErrorDesc] = useState("Проверьте корректность ссылки или присутствие бота в канале/группе");
    const [maxLink, setMaxLink] = useState('');
    const [maxLoading, setMaxLoading] = useState(false);
    const [userInfo, setUserInfo] = useState({});
    const [groups, setGroups] = useState([]);
    const [okGroups, setOkGroups] = useState([]);
    const [premodePosts, setPremodePosts] = useState([]);
    const [channels, setChannels] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [selectedPremodePost, setSelectedPremodePost] = useState(null);
    const [selectedPostText, setSelectedPostText] = useState('')
    const [activeView, setActiveView] = useState('home');
    const [activePanel, setActivePanel] = useState('home');
    const [paidInfo, setPaidInfo] = useState({});
    const [paidInfoLoading, setPaidInfoLoading] = useState(true);
    const [paidInfoError, setPaidInfoError] = useState(false);
    const [paidInfoAttempt, setPaidInfoAttempt] = useState(0);
    const telegramUserId = tg.initDataUnsafe?.user?.id;
    const initialDisplayStyle = Cookies.get('displayStyle') === 'true';
    const [displayStyle, setDisplayStyle] = useState(initialDisplayStyle);
    const initialHideInactive = Cookies.get('hideInactive') === 'true';
    const [hideInactive, setHideInactive] = useState(initialHideInactive);
    const [snackbar, setSnackbar] = React.useState(null);
    const [loadingScreen, setLoadingScreen] = useState('none');
    const [gptLink, setGptLink] = useState("");
    const [gptMedia, setGptMedia] = useState([]);
    const [gptText, setGptText] = useState("");
    const MODAL_CHOOSE = 'modal_choose';
    const [activeModal, setActiveModal] = useState(null);
    const [modalHistory, setModalHistory] = useState([]);
    const [cashlessPsc, setCashlessPsc] = useState(50);
    const [cashlessPdf, setCashlessPdf] = useState("#");
    const [stream, setStream] = useState([]);
    const [selectedStreamIndex, setSelectedStreamIndex] = useState(0);
    const platform = usePlatform();
    const [themes, setThemes] = useState([]);
    const [prompts, setPrompts] = useState([]);

    const [rssAdding, setRssAdding] = useState(false);

    const [readyToOpenPost, setReadyToOpenPost] = useState(false);

    useEffect(() => {
        if (selectedGroup) {
            setChannels(prev => prev.map(ch => ch.id === selectedGroup.id ? selectedGroup : ch));
            setGroups(prev => prev.map(gr => gr.id === selectedGroup.id ? selectedGroup : gr));
            setOkGroups(prev => prev.map(ok => ok.id === selectedGroup.id ? selectedGroup : ok));
        }
    }, [selectedGroup]);

    useEffect(() => {
        if (readyToOpenPost) {
            setActivePanel('post');
            setReadyToOpenPost(false); // сбрасываем, чтобы не сработало снова случайно
        }
    }, [readyToOpenPost]);



    // tg.initDataUnsafe.user.id = 230539739

    const noChannelsOpt = {
        loop: true,
        autoplay: true,
        animationData: noChannels,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const smileOpt = {
        loop: true,
        autoplay: true,
        animationData: smile,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const photoSource = selectedGroup?.photo_200;

    const isBase64Image = photoSource?.startsWith('/9j/');
    const isHttpImage = photoSource?.startsWith('http');

    const avatarSrc = isBase64Image ? `data:image/jpeg;base64,${photoSource}` : (isHttpImage ? photoSource : null);

    const backgroundStyle = tg.colorScheme === 'light'
        ? 'linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.9)), url(https://gmpapp.ru/images/pattern_light.svg) center / auto repeat'
        : 'linear-gradient(rgba(15, 15, 15, 1), rgba(15, 15, 15, 0.9)), url(https://gmpapp.ru/images/pattern_dark.svg) center / auto repeat';

    useEffect(() => {
        const eventSource = new EventSource('https://api.gmpapp.ru/events');

        eventSource.onmessage = async function (event) {
            const data = JSON.parse(event.data);
            const { channel_id, channel_title, channel_admins } = data;
            const currentUserID = tg.initDataUnsafe.user.id;
            const new_channel_id = data.id;

            // Проверка, совпадает ли user_id в channel_admins с currentUserID
            const isAdmin = channel_admins.some((admin) => admin.user_id === currentUserID);

            if (isAdmin) {
                console.log(new_channel_id)
                await selectGroupById(new_channel_id); // Ждем, пока каналы обновятся
            }
        };

        const selectGroupById = async (new_channel) => {
            const url = `https://api.gmpapp.ru/get_channels?tg_id=${tg.initDataUnsafe.user.id}`;
            let fetchedChannels = []; // Создаем временный массив для хранения каналов
            try {
                const response = await axios.get(url);
                fetchedChannels = response.data?.items || []; // Сохраняем каналы во временный массив
                setChannels(fetchedChannels); // Обновляем состояние
                console.log(fetchedChannels);
            } catch (error) {
                console.error('Error while fetching groups:', error);
            } finally {
                setIsLoadingGroups(false);
            }

            // Теперь ищем канал после обновления
            const channel = fetchedChannels.find(channel => channel.id === new_channel);
            console.log(new_channel);
            console.log(fetchedChannels);
            console.log(channel);
            if (channel) {
                setSelectedGroup(channel);
                setActivePanel('onboarding');
            } else {
                console.log('Канал не найден');
            }
        };

        return () => {
            eventSource.close();
        };
    }, [tg.initDataUnsafe.user.id]); // Зависимость только от user.id

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            tg.BackButton.offClick(backButtonHandler);
        };

        // Устанавливаем обработчик нажатия на кнопку "Назад" только если activeView равен 'view1'
        if (activePanel === 'home') {
            tg.BackButton.hide();
            tg.MainButton.hide();
            tg.BackButton.onClick(backButtonHandler);
        } else {
            tg.BackButton.offClick(backButtonHandler); // Удаляем обработчик, если activeView не 'view1'
        }

        // Очистка эффекта
        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel, activeView]);

    useEffect(() => {
        // Обработчик события web_app_open_tg_link
        const handleOpenTgLink = (event) => {
            // Здесь вы можете выполнить нужные действия
            // Например, вы можете извлечь параметры из event.path_full
            const pathFull = event.path_full;
            // Выполните нужные действия в зависимости от pathFull
            // Например, вы можете использовать параметры для навигации или выполнения других действий
        };

        // Подписываемся на событие
        tg.onEvent('web_app_open_tg_link', handleOpenTgLink);

        // Очистка при размонтировании компонента
        return () => {
            tg.offEvent('web_app_open_tg_link', handleOpenTgLink);
        };
    }, []);

    const handleDisplayStyleChange = (value) => {
        setDisplayStyle(value); // Обновляем состояние
        Cookies.set('displayStyle', value, { expires: 365 }); // Сохраняем выбор в cookies на 7 дней
    };

    const handleHideInactiveToggle = () => {
        const newValue = !hideInactive;
        setHideInactive(newValue);
        Cookies.set('hideInactive', newValue, { expires: 365 });
    };

    const openError = (text) => {
        setSnackbar(
            <Snackbar
                onClose={() => setSnackbar(null)}
                before={<Icon28ErrorCircleOutline fill="var(--vkui--color_icon_negative)" />}
            >
                {text}
            </Snackbar>,
        );
    };

    const changeActiveModal = (activeModal) => {
        activeModal = activeModal || null;
        let localModalHistory = modalHistory ? [...modalHistory] : [];

        if (activeModal === null) {
            localModalHistory = [];
        } else if (modalHistory.indexOf(activeModal) !== -1) {
            localModalHistory = localModalHistory.splice(0, localModalHistory.indexOf(activeModal) + 1);
        } else {
            localModalHistory.push(activeModal);
        }

        setActiveModal(activeModal);
        setModalHistory(localModalHistory);
    };

    const modalBack = () => {
        changeActiveModal(modalHistory[modalHistory.length - 2]);
    };

    function sendPostText(selectedPostText) {
        // Формирование объекта с данными
        const dataToSend = {
            post_id: selectedPremodePost.post_id,
            text: selectedPostText
        };

        // URL API
        const apiUrl = 'https://api.gmpapp.ru/save_post';

        // Отправка данных
        axios.post(apiUrl, dataToSend)
            .then((response) => {
                setActiveView('premode');
                tg.showAlert(`Пост успешно сохранен! Он будет опубликован в ${selectedPremodePost.time}`);
            })
            .catch((error) => {
                console.error('Ошибка при отправке данных', error);
            });
    }

    const handleCreateRssFeed = async () => {
        setRssAdding(true);

        try {
            const tg_id = tg.initDataUnsafe.user.id;

            const response = await axios.post("https://api.gmpapp.ru/create_rss_feed", { tg_id });

            const data = response.data;

            if (response.status === 200) {
                console.log("RSS-лента успешно добавлена!");
                console.log("Созданный channel_id:", data.channel_id);

                // Добавим небольшую задержку, чтобы сервер успел сохранить канал
                setTimeout(async () => {
                    const url = `https://api.gmpapp.ru/get_channels?tg_id=${tg_id}`;
                    try {
                        const channelsResponse = await axios.get(url);
                        const fetchedChannels = channelsResponse.data?.items || [];

                        setChannels(fetchedChannels); // Обновляем состояние
                        console.log("Каналы после обновления:", fetchedChannels);

                        // Найдём по полю id, т.к. именно оно используется в каналах
                        const newChannel = fetchedChannels.find(
                            (c) => parseInt(c.id) === parseInt(data.channel_id)
                        );

                        if (newChannel) {
                            setSelectedGroup(newChannel);
                            setActivePanel("onboarding");
                        } else {
                            console.log("Канал не найден");
                        }
                    } catch (fetchError) {
                        setRssAdding(false);
                        console.error("Ошибка при получении каналов:", fetchError);
                    } finally {
                        setRssAdding(false);
                        setIsLoadingGroups(false);
                    }
                }, 500); // Задержка 500мс
            } else {
                console.error("Ошибка при создании RSS-ленты:", data.error);
            }
        } catch (err) {
            setRssAdding(false);
            console.error("Ошибка запроса:", err);
        }
    };


    const handleMaxCheck = async () => {
        const link = maxLink.trim();
        if (!link) {
            setMaxErrorTitle('Ссылка не указана');
            setMaxErrorDesc('Введите ссылку на канал или группу в Max');
            setIsMaxError(true);
            return;
        }

        setMaxLoading(true);
        setIsMaxError(false);

        try {
            const response = await axios.post('https://api.gmpapp.ru/max_check', { link });

            if (response.status === 200) {
                const data = response.data;
                console.log('Max канал добавлен:', data);

                // Обновляем список каналов
                const tg_id = tg.initDataUnsafe.user.id;
                const channelsUrl = `https://api.gmpapp.ru/get_channels?tg_id=${tg_id}`;

                setTimeout(async () => {
                    try {
                        const channelsResponse = await axios.get(channelsUrl);
                        const fetchedChannels = channelsResponse.data?.items || [];
                        setChannels(fetchedChannels);

                        const newChannel = fetchedChannels.find(
                            (c) => parseInt(c.id) === parseInt(data.channel_id)
                        );

                        if (newChannel) {
                            setSelectedGroup(newChannel);
                            setActiveView('home');
                            setActivePanel('onboarding');
                        } else {
                            setActiveView('home');
                        }

                        setMaxLink('');
                    } catch (fetchError) {
                        console.error('Ошибка при обновлении каналов:', fetchError);
                        setActiveView('home');
                    } finally {
                        setMaxLoading(false);
                    }
                }, 500);
            }
        } catch (error) {
            setMaxLoading(false);
            const errMsg = error.response?.data?.error || 'Неизвестная ошибка';
            setMaxErrorTitle('Ошибка');
            setMaxErrorDesc(errMsg);
            setIsMaxError(true);
            console.error('Ошибка max_check:', errMsg);
        }
    };

    useEffect(() => {
        const getUserInfo = async () => {
            try {
                const response = await axios.get(`https://api.gmpapp.ru/get_user_info?tg_id=${tg.initDataUnsafe.user.id}`);
                setUserInfo(response.data);

                if (response.data.paid === false) {
                    setActivePanel('first');
                }
            } catch (error) {
                console.log('Ошибка при получении информации о пользователе:', error);
            }
        };

        const getChannels = async () => {
            const url = `https://api.gmpapp.ru/get_channels?tg_id=${tg.initDataUnsafe.user.id}`;

            try {
                const response = await axios.get(url);
                setChannels(response.data?.items || []);
            } catch (error) {
                console.error('Error while fetching channels:', error);
            } finally {
                setIsLoadingChannels(false);
            }
        };

        const getGroups = async () => {
            const url = `https://api.gmpapp.ru/get_groups?tg_id=${tg.initDataUnsafe.user.id}`;

            try {
                const response = await axios.get(url);
                setGroups(response.data?.response?.items || []);
            } catch (error) {
                console.error('Error while fetching groups:', error);
            } finally {
                setIsLoadingGroups(false);
            }
        };

        const getOkGroups = async () => {
            const url = `https://api.gmpapp.ru/get_ok?tg_id=${tg.initDataUnsafe.user.id}`;

            try {
                const response = await axios.get(url);
                console.log(response)
                setOkGroups(response.data?.response?.items || []);
            } catch (error) {
                console.error('Error while fetching ok groups:', error);
            } finally {
                setIsLoadingOkGroups(false);
            }
        };

        const getPremodePosts = async () => {
            const url = `https://api.gmpapp.ru/get_premode?tg_id=${tg.initDataUnsafe.user.id}`;
            try {
                const response = await axios.get(url);
                setPremodePosts(response.data?.items || []);
            } catch (error) {
                console.error('Error while fetching premode posts:', error);
            }
        };

        const getThemes = async () => {
            try {
                const response = await axios.get('https://api.gmpapp.ru/get_themes');
                const themesData = response.data;
                setThemes(themesData);
            } catch (error) {
                console.log('Ошибка при получении тем:', error);
            }
        };

        const getPrompts = async () => {
            try {
                const response = await axios.get('https://api.gmpapp.ru/get_prompts');
                const promptsData = response.data;
                setPrompts(promptsData);
            } catch (error) {
                console.log('Ошибка при получении промптов:', error);
            }
        };

        getUserInfo();
        getPremodePosts();
        getChannels();
        getGroups();
        getOkGroups();
        getThemes();
        getPrompts();
    }, []);

    useEffect(() => {
        // The balance belongs to the Telegram user; userInfo.id is an optional VK ID.
        if (!telegramUserId) {
            setPaidInfoError(true);
            setPaidInfoLoading(false);
            return;
        }

        const controller = new AbortController();
        const getPaidInfo = async () => {
            setPaidInfoLoading(true);
            setPaidInfoError(false);
            try {
                const response = await axios.get(`https://api.gmpapp.ru/get_paid?id=${telegramUserId}`, {
                    signal: controller.signal,
                    timeout: 15000,
                });
                const quantity = response.data?.quantity;
                if ((typeof quantity !== 'number' && typeof quantity !== 'string') ||
                    String(quantity).trim() === '' || !Number.isFinite(Number(quantity))) {
                    throw new Error('Некорректный остаток постов в ответе сервера');
                }
                if (!controller.signal.aborted) {
                    setPaidInfo({ ...response.data, quantity: Number(quantity) });
                }
            } catch (error) {
                if (!controller.signal.aborted) {
                    setPaidInfoError(true);
                    console.log('Ошибка при получении информации о биллинге:', error);
                }
            } finally {
                if (!controller.signal.aborted) {
                    setPaidInfoLoading(false);
                }
            }
        };

        getPaidInfo();
        return () => controller.abort();
    }, [telegramUserId, paidInfoAttempt]);

    const postsBalance = paidInfoLoading ? (
        <span role="status" style={{ fontSize: 14 }}>Загрузка…</span>
    ) : paidInfoError ? (
        <Button
            mode="link"
            size="s"
            style={{ width: 'auto', height: 'auto', margin: 0 }}
            aria-label="Не удалось загрузить остаток постов. Повторить запрос"
            onClick={() => {
                setPaidInfoLoading(true);
                setPaidInfoAttempt(attempt => attempt + 1);
            }}
        >
            Не загрузилось · повторить
        </Button>
    ) : paidInfo.quantity;

    useEffect(() => {
        if (activeView === 'view2') {
            setTimeout(() => {
                const loginVK = document.querySelector('#loginVK');
                if (loginVK && oneTapButton) {
                    loginVK.appendChild(oneTapButton.getFrame());
                }
            }, 200);
        }
    }, [activeView]);

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const groupId = searchParams.get('group');
        const postId = searchParams.get('post');

        if (!groupId || !postId) return;

        const foundGroup = [...channels, ...groups].find(
            item => item.id.toString() === groupId
        );
        const foundPost = premodePosts.find(
            post => post.post_id.toString() === postId
        );

        // Ждём, пока данные появятся
        if (!foundGroup || !foundPost) return;

        // Когда всё найдено — действуем
        setSelectedGroup(foundGroup);
        setSelectedPremodePost(foundPost);
        setSelectedPostText(foundPost.text);

        const openWhenReady = () => {
            window.history.replaceState(null, '', window.location.pathname);
            setActivePanel('post');
        };

        if (document.readyState === 'complete') {
            openWhenReady();
        } else {
            const handleLoad = () => {
                openWhenReady();
                window.removeEventListener('load', handleLoad);
            };
            window.addEventListener('load', handleLoad);
        }
    }, [channels, groups, premodePosts]); // только данные, параметры из URL — статичны    

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const groupId = searchParams.get('group');
        const postId = searchParams.get('post');

        if (!groupId || !postId) return;

        const timeout = setTimeout(() => {
            const foundGroup = [...channels, ...groups].find(
                item => item.id.toString() === groupId
            );
            const foundPost = premodePosts.find(
                post => post.post_id.toString() === postId
            );

            if (!foundGroup || !foundPost) {
                try {
                    tg.showAlert('Не удалось найти пост');
                } catch (e) {
                    console.warn('Попап уже открыт');
                }
            }
        }, 3000); // ждём 3 секунды

        return () => clearTimeout(timeout);
    }, [channels, groups, premodePosts]);


    useEffect(() => {
        if (activeView === 'view2') {
            setTimeout(() => {
                const loginVK = document.querySelector('#loginVK');
                console.log('Подключаем кнопку VK...')
                if (loginVK) {
                    if (oneTapButton) {
                        loginVK.appendChild(oneTapButton.getFrame());
                    }
                }
            }, 200);
        }
    }, [activeView]);

    return (
        <Root activeView={activeView}>
            <View activePanel={activePanel} id="home">
                <Panel id="home">
                    <Group>
                        <div className="wrapperUI">
                            <>
                                <header className="HeaderBar" style={isMobile ? { marginTop: `calc(var(--tg-content-safe-area-inset-top) + 10px)` } : null}>
                                    {userInfo && (
                                        <>
                                            <div className="topHeader">
                                                <Popover
                                                    action="click"
                                                    content={
                                                        <FormLayout className="PicPopover">
                                                            <FormItem>
                                                                <div className="post_counter">
                                                                    <p>Доступно постов</p>
                                                                    <span>{postsBalance}</span>
                                                                </div>
                                                            </FormItem>
                                                            <FormItem style={{ padding: '10px' }}>
                                                                <Button before={<Icon24DoorArrowRightOutline />} appearance="negative" stretched onClick={() => sendLogout()}>Выйти из аккаунта</Button>
                                                            </FormItem>
                                                        </FormLayout>
                                                    }
                                                >
                                                    <Avatar size={42} className="pic" src={tg.initDataUnsafe.user.photo_url} initials={tg.initDataUnsafe.user.first_name.slice(0, 2)} />
                                                </Popover>
                                                <div className="user_info">
                                                    <p style={{ color: 'var(--vkui--color_text_subhead)' }} className="welcome">Здравствуйте,</p>
                                                    <p style={{ color: 'var(--vkui--color_text_primary)' }} className="first-name">{tg.initDataUnsafe.user.first_name.length > 13 ? `${tg.initDataUnsafe.user.first_name.slice(0, 10)}...` : tg.initDataUnsafe.user.first_name}</p>
                                                </div>
                                                <div className="payBtnUntil" style={{ padding: 0 }}>
                                                    <Button className="pay"
                                                        mode='primary'
                                                        appearance='neutral'
                                                        activated
                                                        before={<Icon20HelpOutline />}
                                                        size='m'
                                                        stretched
                                                        onClick={communityLink}
                                                    >
                                                        Помощь
                                                    </Button>
                                                </div>
                                            </div>
                                            <Spacing style={{ width: "100%" }} size={24}>
                                                <Separator />
                                            </Spacing>
                                            <div className="bottomHeader">
                                                <div className="posts_info">
                                                    <p style={{ color: 'var(--vkui--color_text_subhead)' }} className="posts_header_text">Доступно постов</p>
                                                    <p style={{ color: 'var(--vkui--color_text_primary)' }} className="first-name">{postsBalance}</p>
                                                </div>
                                                <div className="payBtnUntil" style={{ padding: 0 }}>
                                                    <Button className="pay"
                                                        mode='primary'
                                                        appearance='neutral'
                                                        activated
                                                        before={<Icon20MoneyCircleOutline />}
                                                        size='m'
                                                        stretched
                                                        onClick={() => {
                                                            tg.HapticFeedback.impactOccurred('heavy');
                                                            tg.HapticFeedback.notificationOccurred("success");
                                                            setActivePanel('payment');
                                                        }}
                                                    >
                                                        Купить посты
                                                    </Button>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </header>
                            </>
                            <div className="modal_choose_full">
                                <ModalRoot activeModal={activeModal} onClose={modalBack}>
                                    <ModalCard
                                        id={MODAL_CHOOSE}
                                        className="modal_choose"
                                        onClose={() => changeActiveModal(null)}
                                        header="Выберите сервис"
                                        actions={
                                            <React.Fragment>
                                                <CardGrid size="m" style={{ padding: '0' }}>
                                                    <Card>
                                                        <Banner
                                                            className="groupItem"
                                                            style={{ margin: '0' }}
                                                            header="VK"
                                                            asideMode="expand"
                                                            before={
                                                                <Avatar
                                                                    className="groupImage"
                                                                    size={50}
                                                                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/VK_Compact_Logo_%282021-present%29.svg/2048px-VK_Compact_Logo_%282021-present%29.svg.png"
                                                                >
                                                                </Avatar>
                                                            }
                                                            onClick={() => {
                                                                changeActiveModal(null);
                                                                setActiveView('view2');
                                                            }}
                                                        />
                                                    </Card>
                                                    <Card>
                                                        <Banner
                                                            className="groupItem"
                                                            style={{ margin: '0' }}
                                                            header="Telegram"
                                                            asideMode="expand"
                                                            before={
                                                                <Avatar
                                                                    className="groupImage"
                                                                    size={50}
                                                                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Telegram_logo.svg/2048px-Telegram_logo.svg.png"
                                                                >
                                                                </Avatar>
                                                            }
                                                            onClick={() => {
                                                                tg.openTgLink('https://t.me/GiveMePublicBot?startchannel&admin=post_messages');
                                                            }}
                                                        />
                                                    </Card>
                                                </CardGrid>
                                            </React.Fragment>
                                        }
                                    />
                                </ModalRoot>
                            </div>
                            {(channels?.length > 0 || groups?.length > 0) && (
                                <div className="postheader">
                                    <SegmentedControl
                                        className="channelsSegmented"
                                        onChange={handleDisplayStyleChange}
                                        defaultValue={displayStyle}
                                        options={[
                                            {
                                                'label': <Icon16GridOfFour />,
                                                'value': false,
                                                'aria-label': 'Плитки',
                                            },
                                            {
                                                'label': <Icon24List />,
                                                'value': true,
                                                'aria-label': 'Список',
                                            },
                                        ]}
                                    />
                                    {/* <div
                                        className="hideInactiveBtn"
                                        onClick={handleHideInactiveToggle}
                                        title={hideInactive ? 'Показать неактивные' : 'Скрыть неактивные'}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            padding: '6px',
                                            borderRadius: '8px',
                                            background: hideInactive ? 'var(--vkui--color_background_secondary_alpha)' : 'transparent',
                                            opacity: hideInactive ? 1 : 0.5,
                                            transition: 'all 0.2s ease',
                                        }}
                                    >
                                        {hideInactive ? <Icon20HideOutline /> : <Icon20ViewOutline />}
                                    </div> */}
                                    <AppRoot platform="ios">
                                        <Modal
                                            className="ModalChannels"
                                            header={<Modal.Header>Выберите социальную сеть</Modal.Header>}
                                            trigger={
                                                <Button className="addChannel"
                                                    style={{ color: baseTheme.colorTextContrast.normal, backgroundColor: baseTheme.colorAccentBlue.normal }}
                                                    before={<Icon20AddCircleOutline />}
                                                    size='l'
                                                    stretched
                                                >
                                                    Куда постить
                                                </Button>
                                            }
                                            style={{
                                                background: 'var(--vkui--color_background_content)',
                                            }}
                                        >
                                            <List
                                                style={{
                                                    background: 'var(--vkui--color_background_content)',
                                                }}
                                            >
                                                <Section
                                                    className="channelsAddSection"
                                                    footer="*Facebook/Instagram — проект Meta Platforms Inc., деятельность которой в России запрещена и признана экстремистской"
                                                    header="Социальные сети"
                                                    style={{ paddingBottom: "40px", background: "none" }}
                                                >
                                                    <CellTG onClick={() => { tg.openTelegramLink('https://t.me/GiveMePublicBot?startchannel&admin=post_messages+edit_messages+restrict_members+pin_messages+manage_chat+delete_messages'); }} className="channelAddItem" before={<TelegramIcon style={{ width: "30px", height: "30px" }} />}>
                                                        Telegram-канал
                                                    </CellTG>
                                                    <CellTG onClick={() => { tg.openTelegramLink('https://t.me/GiveMePublicBot?startgroup&admin=post_messages+edit_messages+restrict_members+pin_messages+manage_chat+delete_messages'); }} className="channelAddItem" before={<TelegramIcon style={{ width: "30px", height: "30px" }} />}>
                                                        Telegram-группа
                                                    </CellTG>
                                                    <CellTG onClick={() => { setActiveView('view2'); }} className="channelAddItem" before={<VkIcon style={{ width: "30px", height: "30px" }} />}>
                                                        VK
                                                    </CellTG>
                                                    <CellTG onClick={handleCreateRssFeed} className="channelAddItem" after={rssAdding ? <Spinner size="small" /> : null} before={<RSSIcon style={{ width: "30px", height: "30px" }} />}>
                                                        RSS-лента
                                                    </CellTG>
                                                    <CellTG onClick={okAuth} className="channelAddItem" before={<OdnoklassnikiIcon style={{ width: "30px", height: "30px" }} />}>
                                                        Одноклассники
                                                    </CellTG>
                                                    <CellTG onClick={() => { setActiveView('addMax'); }} className="channelAddItem" before={<MaxIcon style={{ width: "30px", height: "30px" }} />}>
                                                        Max
                                                    </CellTG>
                                                    <CellTG className="channelAddItem soonItem" after={<Badge type="number">СКОРО</Badge>} before={<DzenIcon style={{ width: "30px", height: "30px" }} />}>
                                                        Дзен
                                                    </CellTG>
                                                    <CellTG className="channelAddItem soonItem" after={<Badge type="number">СКОРО</Badge>} before={<InstagramIcon style={{ width: "30px", height: "30px" }} />}>
                                                        Instagram*
                                                    </CellTG>
                                                    <CellTG className="channelAddItem soonItem" after={<Badge type="number">СКОРО</Badge>} before={<FacebookIcon style={{ width: "30px", height: "30px" }} />}>
                                                        Facebook*
                                                    </CellTG>
                                                    <CellTG className="channelAddItem soonItem" after={<Badge type="number">СКОРО</Badge>} before={<XIcon style={{ width: "30px", height: "30px" }} />}>
                                                        X/Twitter
                                                    </CellTG>
                                                </Section>
                                            </List>
                                        </Modal>
                                    </AppRoot>
                                </div>
                            )}
                            {channels?.length < 1 && groups?.length < 1 && (
                                <React.Fragment>
                                    <Div className={isLoadingChannels || isLoadingGroups ? "loader-hidden" : "no_data"}>
                                        <Lottie
                                            isClickToPauseDisabled={true}
                                            options={smileOpt}
                                            height={150}
                                            width={150}
                                        />
                                        <div className="welcome_no">
                                            <Text className="welcomeHeadline" normalize={true} weight="1">Выберите канал, который нужно вести</Text>
                                        </div>
                                        <Text style={{ textAlign: "center" }} className="welcomeDesc" normalize={true} weight="3">(для начала рекомендуем завести тестовый)</Text>
                                        <AppRoot platform="ios">
                                            <Modal
                                                className="ModalChannels"
                                                header={<Modal.Header>Выберите социальную сеть</Modal.Header>}
                                                trigger={
                                                    <Button className="addChannel"
                                                        style={{ color: baseTheme.colorTextContrast.normal, backgroundColor: baseTheme.colorAccentBlue.normal }}
                                                        before={<Icon20AddCircleOutline />}
                                                        size='l'
                                                        stretched
                                                    >
                                                        Выбрать канал
                                                    </Button>
                                                }
                                                style={{
                                                    background: 'var(--vkui--color_background_content)',
                                                }}
                                            >
                                                <List
                                                    style={{
                                                        background: 'var(--vkui--color_background_content)',
                                                    }}
                                                >
                                                    <Section
                                                        footer="*Facebook/Instagram — проект Meta Platforms Inc., деятельность которой в России запрещена и признана экстремистской"
                                                        header="Социальные сети"
                                                        style={{ paddingBottom: "40px", background: "none" }}
                                                    >
                                                        <CellTG onClick={() => { tg.openTelegramLink('https://t.me/GiveMePublicBot?startchannel&admin=post_messages+edit_messages+restrict_members+pin_messages+manage_chat+delete_messages'); }} className="channelAddItem" before={<TelegramIcon style={{ width: "30px", height: "30px" }} />}>
                                                            Telegram-канал
                                                        </CellTG>
                                                        <CellTG onClick={() => { tg.openTelegramLink('https://t.me/GiveMePublicBot?startgroup&admin=post_messages+edit_messages+restrict_members+pin_messages+manage_chat+delete_messages'); }} className="channelAddItem" before={<TelegramIcon style={{ width: "30px", height: "30px" }} />}>
                                                            Telegram-группа
                                                        </CellTG>
                                                        <CellTG onClick={() => { setActiveView('view2'); }} className="channelAddItem" before={<VkIcon style={{ width: "30px", height: "30px" }} />}>
                                                            VK
                                                        </CellTG>
                                                        <CellTG className="channelAddItem soonItem" after={<Badge type="number">СКОРО</Badge>} before={<DzenIcon style={{ width: "30px", height: "30px" }} />}>
                                                            Дзен
                                                        </CellTG>
                                                        <CellTG className="channelAddItem soonItem" after={<Badge type="number">СКОРО</Badge>} before={<InstagramIcon style={{ width: "30px", height: "30px" }} />}>
                                                            Instagram*
                                                        </CellTG>
                                                        <CellTG className="channelAddItem soonItem" after={<Badge type="number">СКОРО</Badge>} before={<FacebookIcon style={{ width: "30px", height: "30px" }} />}>
                                                            Facebook*
                                                        </CellTG>
                                                        <CellTG className="channelAddItem soonItem" after={<Badge type="number">СКОРО</Badge>} before={<XIcon style={{ width: "30px", height: "30px" }} />}>
                                                            X/Twitter
                                                        </CellTG>
                                                    </Section>
                                                </List>
                                            </Modal>
                                        </AppRoot>
                                    </Div>
                                </React.Fragment>
                            )}
                            {channels.some(channel => channel.id.toString().startsWith('-200') && (!hideInactive || channel.active)) && (
                                <div className="userGroupsView">
                                    <span className={`userGroups ${displayStyle ? 'listView' : ''}`}>
                                        <React.Fragment>
                                            <Div className="type-group" style={{ padding: 0 }}>
                                                <Head mode="secondary">RSS-ленты</Head>
                                            </Div>
                                        </React.Fragment>

                                        <CardGrid size="m" style={{ padding: '0' }}>
                                            {channels.filter(channel => channel.id.toString().startsWith('-200') && (!hideInactive || channel.active)).map((channel, index) => (
                                                <Card className={`${channel.active ? '' : 'inactiveItem'}`}>
                                                    <Banner
                                                        key={index}
                                                        className="groupItem"
                                                        style={{ margin: '0' }}
                                                        before={
                                                            <Avatar
                                                                className="groupImage"
                                                                size={50}
                                                                initials={channel.name.slice(0, 2)}
                                                                src={`data:image/jpeg;base64,${channel.photo_200}`}
                                                            >
                                                                <Avatar.Badge style={{ background: 'var(--vkui--color_background_secondary)' }}>
                                                                    <Icon24CircleSmall color={channel.active ? baseTheme.colorAccentGreen.normal : baseTheme.colorAccentRed.normal} width={16} height={16} />
                                                                </Avatar.Badge>
                                                            </Avatar>
                                                        }
                                                        header={channel.name}
                                                        asideMode="expand"
                                                        onClick={() => {
                                                            tg.HapticFeedback.impactOccurred('heavy');
                                                            tg.HapticFeedback.notificationOccurred("success");
                                                            setSelectedGroup(channel);
                                                            console.log(selectedGroup)
                                                            setActivePanel('channel');
                                                        }}
                                                    />
                                                </Card>
                                            ))}
                                        </CardGrid>
                                    </span>
                                </div>
                            )}
                            {channels.some(channel => channel.group && (!hideInactive || channel.active)) && (
                                <div className="userGroupsView">
                                    <span className={`userGroups ${displayStyle ? 'listView' : ''}`}>
                                        <React.Fragment>
                                            <Div className="type-group" style={{ padding: 0 }}>
                                                <Head mode="secondary">Telegram-группы</Head>
                                            </Div>
                                        </React.Fragment>

                                        <CardGrid size="m" style={{ padding: '0' }}>
                                            {channels.filter(channel => channel.group && (!hideInactive || channel.active)).map((channel, index) => (
                                                <Card className={`${channel.active ? '' : 'inactiveItem'}`}>
                                                    <Banner
                                                        key={index}
                                                        className="groupItem"
                                                        style={{ margin: '0' }}
                                                        before={
                                                            <Avatar
                                                                className="groupImage"
                                                                size={50}
                                                                initials={channel.name.slice(0, 2)}
                                                                src={`data:image/jpeg;base64,${channel.photo_200}`}
                                                            >
                                                                <Avatar.Badge style={{ background: 'var(--vkui--color_background_secondary)' }}>
                                                                    <Icon24CircleSmall color={channel.active ? baseTheme.colorAccentGreen.normal : baseTheme.colorAccentRed.normal} width={16} height={16} />
                                                                </Avatar.Badge>
                                                            </Avatar>
                                                        }
                                                        header={channel.name}
                                                        subheader={`${channel.members_count} участников`}
                                                        asideMode="expand"
                                                        onClick={() => {
                                                            tg.HapticFeedback.impactOccurred('heavy');
                                                            tg.HapticFeedback.notificationOccurred("success");
                                                            setSelectedGroup(channel);
                                                            console.log(selectedGroup)
                                                            setActivePanel('channel');
                                                        }}
                                                    />
                                                </Card>
                                            ))}
                                        </CardGrid>
                                    </span>
                                </div>
                            )}
                            <div className="userGroupsView">
                                <span className={`userGroups ${displayStyle ? 'listView' : ''}`}>
                                    {channels.some(channel => channel.id.toString().startsWith('-100') && !channel.group && (!hideInactive || channel.active)) && (
                                        <React.Fragment>
                                            <Div className="type-group" style={{ padding: 0 }}>
                                                <Head mode="secondary">Telegram-каналы</Head>
                                            </Div>
                                        </React.Fragment>
                                    )}
                                    <CardGrid size="m" style={{ padding: '0' }}>
                                        {channels.filter(channel => channel.id.toString().startsWith('-100') && !channel.group && (!hideInactive || channel.active)).map((channel, index) => (
                                            <Card className={`${channel.active ? '' : 'inactiveItem'}`}>
                                                <Banner
                                                    key={index}
                                                    className="groupItem"
                                                    style={{ margin: '0' }}
                                                    before={
                                                        <Avatar
                                                            className="groupImage"
                                                            size={50}
                                                            initials={channel.name.slice(0, 2)}
                                                            src={`data:image/jpeg;base64,${channel.photo_200}`}
                                                        >
                                                            <Avatar.Badge style={{ background: 'var(--vkui--color_background_secondary)' }}>
                                                                <Icon24CircleSmall color={channel.active ? baseTheme.colorAccentGreen.normal : baseTheme.colorAccentRed.normal} width={16} height={16} />
                                                            </Avatar.Badge>
                                                        </Avatar>
                                                    }
                                                    header={channel.name}
                                                    subheader={`${channel.members_count} подписчиков`}
                                                    asideMode="expand"
                                                    onClick={() => {
                                                        tg.HapticFeedback.impactOccurred('heavy');
                                                        tg.HapticFeedback.notificationOccurred("success");
                                                        setSelectedGroup(channel);
                                                        console.log(selectedGroup)
                                                        setActivePanel('channel');
                                                    }}
                                                />
                                            </Card>
                                        ))}
                                    </CardGrid>
                                </span>
                            </div>
                            <div className="userGroupsView">
                                <span className={`userGroups ${displayStyle ? 'listView' : ''}`}>
                                    {groups.some(g => !hideInactive || g.active) && (
                                        <React.Fragment>
                                            <Div className="type-group" style={{ padding: 0 }}>
                                                <Head mode="secondary">Группы/паблики VK</Head>
                                            </Div>
                                        </React.Fragment>
                                    )}

                                    <CardGrid size="m" style={{ padding: '0' }}>
                                        {groups.filter(g => !hideInactive || g.active).map((group, index) => (
                                            <Card className={`${group.active ? '' : 'inactiveItem'}`}>
                                                <Banner
                                                    key={index}
                                                    className="groupItem"
                                                    style={{ margin: '0' }}
                                                    before={
                                                        <Avatar
                                                            className="groupImage"
                                                            size={50}
                                                            src={group.photo_200}
                                                        >
                                                            <Avatar.Badge style={{ background: 'var(--vkui--color_background_secondary)' }}>
                                                                <Icon24CircleSmall color={group.active ? baseTheme.colorAccentGreen.normal : baseTheme.colorAccentRed.normal} width={16} height={16} />
                                                            </Avatar.Badge>
                                                        </Avatar>
                                                    }
                                                    header={group.name}
                                                    subheader={`${group.members_count} подписчиков`}
                                                    asideMode="expand"
                                                    onClick={() => {
                                                        tg.HapticFeedback.impactOccurred('heavy');
                                                        tg.HapticFeedback.notificationOccurred("success");
                                                        setSelectedGroup(group);
                                                        console.log(selectedGroup)
                                                        setActivePanel('channel');
                                                    }}
                                                />
                                            </Card>
                                        ))}
                                    </CardGrid>
                                </span>
                            </div>
                            <div className="userGroupsView">
                                <span className={`userGroups ${displayStyle ? 'listView' : ''}`}>
                                    {okGroups.some(g => !hideInactive || g.active) && (
                                        <React.Fragment>
                                            <Div className="type-group" style={{ padding: 0 }}>
                                                <Head mode="secondary">Группы Одноклассники</Head>
                                            </Div>
                                        </React.Fragment>
                                    )}

                                    <CardGrid size="m" style={{ padding: '0' }}>
                                        {okGroups.filter(g => !hideInactive || g.active).map((group, index) => (
                                            <Card className={`${group.active ? '' : 'inactiveItem'}`}>
                                                <Banner
                                                    key={index}
                                                    className="groupItem"
                                                    style={{ margin: '0' }}
                                                    before={
                                                        <Avatar
                                                            className="groupImage"
                                                            size={50}
                                                            src={group.photo_200}
                                                            initials={group.name.slice(0, 2)}
                                                        >
                                                            <Avatar.Badge style={{ background: 'var(--vkui--color_background_secondary)' }}>
                                                                <Icon24CircleSmall color={group.active ? baseTheme.colorAccentGreen.normal : baseTheme.colorAccentRed.normal} width={16} height={16} />
                                                            </Avatar.Badge>
                                                        </Avatar>
                                                    }
                                                    header={group.name}
                                                    subheader={`${group.members_count} подписчиков`}
                                                    asideMode="expand"
                                                    onClick={() => {
                                                        tg.HapticFeedback.impactOccurred('heavy');
                                                        tg.HapticFeedback.notificationOccurred("success");
                                                        setSelectedGroup(group);
                                                        console.log(selectedGroup)
                                                        setActivePanel('channel');
                                                    }}
                                                />
                                            </Card>
                                        ))}
                                    </CardGrid>
                                </span>
                            </div>
                            {channels.some(channel => {
                                const id = channel.id.toString();
                                return id.startsWith('-') && !id.startsWith('-100') && !id.startsWith('-200') && !id.startsWith('-30') && (!hideInactive || channel.active);
                            }) && (
                                <div className="userGroupsView">
                                    <span className={`userGroups ${displayStyle ? 'listView' : ''}`}>
                                        <React.Fragment>
                                            <Div className="type-group" style={{ padding: 0 }}>
                                                <Head mode="secondary">Каналы Max</Head>
                                            </Div>
                                        </React.Fragment>

                                        <CardGrid size="m" style={{ padding: '0' }}>
                                            {channels.filter(channel => {
                                                const id = channel.id.toString();
                                                return id.startsWith('-') && !id.startsWith('-100') && !id.startsWith('-200') && !id.startsWith('-30') && (!hideInactive || channel.active);
                                            }).map((channel, index) => (
                                                <Card className={`${channel.active ? '' : 'inactiveItem'}`}>
                                                    <Banner
                                                        key={index}
                                                        className="groupItem"
                                                        style={{ margin: '0' }}
                                                        before={
                                                            <Avatar
                                                                className="groupImage"
                                                                size={50}
                                                                initials={channel.name.slice(0, 2)}
                                                                src={channel.photo_200?.startsWith('http') ? channel.photo_200 : `data:image/jpeg;base64,${channel.photo_200}`}
                                                            >
                                                                <Avatar.Badge style={{ background: 'var(--vkui--color_background_secondary)' }}>
                                                                    <Icon24CircleSmall color={channel.active ? baseTheme.colorAccentGreen.normal : baseTheme.colorAccentRed.normal} width={16} height={16} />
                                                                </Avatar.Badge>
                                                            </Avatar>
                                                        }
                                                        header={channel.name}
                                                        subheader={`${channel.members_count} подписчиков`}
                                                        asideMode="expand"
                                                        onClick={() => {
                                                            tg.HapticFeedback.impactOccurred('heavy');
                                                            tg.HapticFeedback.notificationOccurred("success");
                                                            setSelectedGroup(channel);
                                                            console.log(selectedGroup)
                                                            setActivePanel('channel');
                                                        }}
                                                    />
                                                </Card>
                                            ))}
                                        </CardGrid>
                                    </span>
                                </div>
                            )}
                        </div>
                    </Group>
                </Panel>
                <Panel id="payment">
                    <PayPage activePanel={activePanel} setActivePanel={setActivePanel} cashlessPsc={cashlessPsc} setCashlessPsc={setCashlessPsc} cashlessPdf={cashlessPdf} setCashlessPdf={setCashlessPdf} openError={openError} activeView={activeView} setActiveView={setActiveView} userInfo={userInfo} snackbar={snackbar} postsBalance={postsBalance} isMobile={isMobile} />
                </Panel>
                <Panel id="channel">
                    <ChannelPageTest activePanel={activePanel} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} setActivePanel={setActivePanel} avatarSrc={avatarSrc} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} premodePosts={premodePosts} setChannels={setChannels} setGroups={setGroups} setPremodePosts={setPremodePosts} stream={stream} setStream={setStream} selectedStreamIndex={selectedStreamIndex} openError={openError} setSelectedStreamIndex={setSelectedStreamIndex} />
                </Panel>
                <Panel id="streams">
                    <StreamsPage activePanel={activePanel} setActivePanel={setActivePanel} userInfo={userInfo} FaTelegram={FaTelegram} baseTheme={baseTheme} avatarSrc={avatarSrc} isMobile={isMobile} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} activeView={activeView} setActiveView={setActiveView} premodePosts={premodePosts} />
                </Panel>
                <Panel id="rss">
                    <RssPage activePanel={activePanel} setActivePanel={setActivePanel} userInfo={userInfo} FaTelegram={FaTelegram} baseTheme={baseTheme} avatarSrc={avatarSrc} isMobile={isMobile} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} activeView={activeView} setActiveView={setActiveView} premodePosts={premodePosts} />
                </Panel>
                <Panel id="sources">
                    <SourcesPage activePanel={activePanel} setActivePanel={setActivePanel} userInfo={userInfo} FaTelegram={FaTelegram} baseTheme={baseTheme} avatarSrc={avatarSrc} isMobile={isMobile} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} activeView={activeView} setActiveView={setActiveView} premodePosts={premodePosts} stream={stream} setStream={setStream} />
                </Panel>
                <Panel id="posts">
                    <PremodePage setSelectedPostText={setSelectedPostText} setSelectedPremodePost={setSelectedPremodePost} activePanel={activePanel} setActivePanel={setActivePanel} userInfo={userInfo} FaTelegram={FaTelegram} baseTheme={baseTheme} avatarSrc={avatarSrc} isMobile={isMobile} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} activeView={activeView} setActiveView={setActiveView} openError={openError} premodePosts={premodePosts} setPremodePosts={setPremodePosts} />
                </Panel>
                <Panel id="post">
                    <PostPage selectedPremodePost={selectedPremodePost} showAlert={tg.showAlert} setSelectedPostText={setSelectedPostText} setSelectedPremodePost={setSelectedPremodePost} activePanel={activePanel} setActivePanel={setActivePanel} userInfo={userInfo} FaTelegram={FaTelegram} baseTheme={baseTheme} avatarSrc={avatarSrc} isMobile={isMobile} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} activeView={activeView} setActiveView={setActiveView} premodePosts={premodePosts} setPremodePosts={setPremodePosts} />
                </Panel>
                <Panel id="posting">
                    <PostingPage activePanel={activePanel} setActivePanel={setActivePanel} userInfo={userInfo} FaTelegram={FaTelegram} baseTheme={baseTheme} avatarSrc={avatarSrc} isMobile={isMobile} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} activeView={activeView} setActiveView={setActiveView} premodePosts={premodePosts} />
                </Panel>
                <Panel id="timers">
                    <TimersPage activePanel={activePanel} setActivePanel={setActivePanel} userInfo={userInfo} FaTelegram={FaTelegram} baseTheme={baseTheme} avatarSrc={avatarSrc} isMobile={isMobile} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} activeView={activeView} setActiveView={setActiveView} premodePosts={premodePosts} stream={stream} setStream={setStream} />
                </Panel>
                <Panel id="filter">
                    <FilterPage activePanel={activePanel} setActivePanel={setActivePanel} userInfo={userInfo} FaTelegram={FaTelegram} baseTheme={baseTheme} avatarSrc={avatarSrc} isMobile={isMobile} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} activeView={activeView} setActiveView={setActiveView} premodePosts={premodePosts} stream={stream} setStream={setStream} />
                </Panel>
                <Panel id="style">
                    <StylePage activePanel={activePanel} setActivePanel={setActivePanel} userInfo={userInfo} FaTelegram={FaTelegram} baseTheme={baseTheme} avatarSrc={avatarSrc} isMobile={isMobile} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} activeView={activeView} setActiveView={setActiveView} premodePosts={premodePosts} stream={stream} setStream={setStream} />
                </Panel>
                <Panel id="digest">
                    <DigestPage activePanel={activePanel} setActivePanel={setActivePanel} userInfo={userInfo} FaTelegram={FaTelegram} baseTheme={baseTheme} avatarSrc={avatarSrc} isMobile={isMobile} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} activeView={activeView} setActiveView={setActiveView} premodePosts={premodePosts} stream={stream} setStream={setStream} />
                </Panel>
                <Panel id="onboarding">
                    <OnboardingPage activePanel={activePanel} setActivePanel={setActivePanel} avatarSrc={avatarSrc} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} premodePosts={premodePosts} setChannels={setChannels} setGroups={setGroups} setPremodePosts={setPremodePosts} stream={stream} setStream={setStream} selectedStreamIndex={selectedStreamIndex} setSelectedStreamIndex={setSelectedStreamIndex} />
                </Panel>
                <Panel id="topics">
                    <TopicsPage activePanel={activePanel} setActivePanel={setActivePanel} avatarSrc={avatarSrc} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} premodePosts={premodePosts} setChannels={setChannels} setGroups={setGroups} setPremodePosts={setPremodePosts} stream={stream} setStream={setStream} selectedStreamIndex={selectedStreamIndex} setSelectedStreamIndex={setSelectedStreamIndex} />
                </Panel>
                <Panel id="add">
                    <OnboardingAddPage activePanel={activePanel} setActivePanel={setActivePanel} avatarSrc={avatarSrc} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} premodePosts={premodePosts} setChannels={setChannels} setGroups={setGroups} setPremodePosts={setPremodePosts} stream={stream} setStream={setStream} selectedStreamIndex={selectedStreamIndex} setSelectedStreamIndex={setSelectedStreamIndex} />
                </Panel>
                <Panel id="other">
                    <OtherPage activePanel={activePanel} setActivePanel={setActivePanel} userInfo={userInfo} FaTelegram={FaTelegram} baseTheme={baseTheme} avatarSrc={avatarSrc} isMobile={isMobile} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} activeView={activeView} setActiveView={setActiveView} premodePosts={premodePosts} stream={stream} setStream={setStream} />
                </Panel>
                <Panel id="testgpt">
                    <TestDrivePage activePanel={activePanel} setActivePanel={setActivePanel} gptLink={gptLink} gptMedia={gptMedia} gptText={gptText} userInfo={userInfo} FaTelegram={FaTelegram} baseTheme={baseTheme} avatarSrc={avatarSrc} isMobile={isMobile} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} activeView={activeView} setActiveView={setActiveView} premodePosts={premodePosts} stream={stream} setStream={setStream} />
                </Panel>
                <Panel id="prompts">
                    <PromptsPage activePanel={activePanel} themes={themes} setActivePanel={setActivePanel} gptLink={gptLink} gptMedia={gptMedia} gptText={gptText} userInfo={userInfo} FaTelegram={FaTelegram} baseTheme={baseTheme} avatarSrc={avatarSrc} isMobile={isMobile} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} activeView={activeView} setActiveView={setActiveView} premodePosts={premodePosts} stream={stream} setStream={setStream} prompts={prompts} />
                </Panel>
                <Panel id="sourceslib">
                    <SourcesLibPage activePanel={activePanel} themes={themes} setActivePanel={setActivePanel} gptLink={gptLink} gptMedia={gptMedia} gptText={gptText} userInfo={userInfo} FaTelegram={FaTelegram} baseTheme={baseTheme} avatarSrc={avatarSrc} isMobile={isMobile} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} activeView={activeView} setActiveView={setActiveView} premodePosts={premodePosts} stream={stream} setStream={setStream} />
                </Panel>
                <Panel id="team">
                    <TeamPage activePanel={activePanel} themes={themes} setActivePanel={setActivePanel} setChannels={setChannels} setGroups={setGroups} gptLink={gptLink} gptMedia={gptMedia} gptText={gptText} userInfo={userInfo} FaTelegram={FaTelegram} baseTheme={baseTheme} avatarSrc={avatarSrc} isMobile={isMobile} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} activeView={activeView} setActiveView={setActiveView} premodePosts={premodePosts} stream={stream} setStream={setStream} />
                </Panel>
                <Panel id="first">
                    <div className="wrapperUI">
                        <Group className="groupsPaid" mode="plain">
                            <div style={{ paddingTop: 10, textAlign: "center" }}>
                                <Text weight="1">Добро пожаловать в <b>GiveMePublic!</b></Text>
                            </div>
                            <div className="quantityGroups">
                                <p style={{ color: "#f8f8f8", marginTop: "0px", textAlign: "center", fontSize: "18px", opacity: '.8' }}>Вам доступно</p>
                                <div className="groupsControls">
                                    <span style={{ color: baseTheme.colorAccentBlue.normal }}
                                    >30</span>
                                </div>
                                <p style={{ color: "#f8f8f8", marginTop: "0px", textAlign: "center", fontSize: "18px", opacity: '.8' }}>Пробных постов для использования</p>
                                {/* <p style={{ color: "#f8f8f8", marginTop: "30px", marginBottom: 0, textAlign: "center", fontSize: "18px", fontWeight: '700' }}>Чтобы начать пользоваться сервисом, давайте добавим ваш Telegram-канал</p> */}
                            </div>
                            <div className="payGroupsFooter">
                                <Button className="addChannel"
                                    style={{ color: baseTheme.colorTextContrast.normal, backgroundColor: baseTheme.colorAccentBlue.normal, height: "52px", marginBottom: "6px" }}
                                    size='s'
                                    stretched='true'
                                    onClick={() => {
                                        axios.post('https://api.gmpapp.ru/post_pay', {
                                            userId: window.Telegram.WebApp.initDataUnsafe.user.id,
                                            paid: true
                                        })
                                            .then(response => {
                                                setActivePanel('home');
                                            })
                                            .catch(error => {
                                                console.log('Ошибка POST-запроса:', error);
                                            });
                                    }}
                                >
                                    Начать пробный период
                                </Button>
                            </div>
                        </Group>
                    </div>
                </Panel>
                <Panel id="loading">
                    <div className="overlaySpinnerFirst">
                        <Spinner size="large" />
                    </div>
                </Panel>
            </View>
            <View activePanel="panel2.1" id="view2">
                <Panel id="panel2.1">
                    <PanelHeader
                        before={
                            <PanelHeaderBack
                                onClick={() => {
                                    setActiveView('home');
                                }}
                                label={platform === Platform.VKCOM ? 'Назад' : undefined}
                            />
                        }
                    >Выберите группу/паблик VK</PanelHeader>
                    {!userInfo.token && (
                        <Div className="VKlogin">
                            <Text>Чтобы увидеть группы/паблики в которых вы являетесь администратором, выполните вход через VK ID по кнопке ниже</Text>
                            <div id="loginVK"></div>
                        </Div>
                    )}
                    {userInfo.token && (
                        <Div className="VKlogin">
                            <Text>Вы уже выполнили вход через VK ID. На главном экране отображаются все паблики/группы, где вы являетесь администратором.</Text>
                        </Div>
                    )}
                </Panel>
            </View>
            <View activePanel="maxPanel" id="addMax">
                <Panel id="maxPanel">
                    <PanelHeader
                        before={
                            <PanelHeaderBack
                                onClick={() => {
                                    setActiveView('home');
                                }}
                                label={platform === Platform.VKCOM ? 'Назад' : undefined}
                            />
                        }
                    >Подключение Max</PanelHeader>
                    <Div className="MaxConnect">
                        <p style={{ color: 'var(--vkui--color_text_primary)', padding: "12px", fontSize: "medium" }}>Найдите <b>GiveMePublic id344200694357_bot</b>, добавьте его в контакты, затем сначала добавьте его в свой канал/группу в качестве подписчика, а затем — в качестве администратора.<br /><br />После этого введите ссылку на ваш канал/группу ниже и нажмите «Добавить»</p>
                        {isMaxError && (
                            <FormStatus header={maxErrorTitle} mode="error">
                                {maxErrorDesc}
                            </FormStatus>
                        )}
                        <FormItem htmlFor="max" top={(<div>Ссылка на канал/группу в Max</div>)}>
                            <Input id="max" placeholder="Введите ссылку..." value={maxLink} onChange={(e) => setMaxLink(e.target.value)} />
                            <Button className="addChannel"
                                style={{ color: baseTheme.colorTextContrast.normal, backgroundColor: baseTheme.colorAccentBlue.normal, marginTop: "12px" }}
                                before={maxLoading ? <Spinner size="small" /> : <Icon20AddCircleOutline />}
                                size='l'
                                stretched
                                disabled={maxLoading}
                                onClick={handleMaxCheck}
                            >
                                {maxLoading ? 'Проверяем...' : 'Добавить'}
                            </Button>
                        </FormItem>
                    </Div>
                </Panel>
            </View>
            {/* <View activePanel="channels" id="channels_view">
                <Panel id="channels">
                    <Group className="channelsHeader" style={isMobile ? { marginTop: `calc(var(--tg-content-safe-area-inset-top) + 10px)` } : null}>
                        <ChannelPageTest userInfo={userInfo} FaTelegram={FaTelegram} baseTheme={baseTheme} avatarSrc={avatarSrc} isMobile={isMobile} setGptLink={setGptLink} setGptMedia={setGptMedia} setGptText={setGptText} selectedGroup={selectedGroup} activeView={activeView} setActiveView={setActiveView} premodePosts={premodePosts} />
                    </Group>
                </Panel>
            </View> */}
            {/* <View activePanel="panel4.1" id="paid">
                <Panel id="panel4.1">
                    <div className="wrapperUI">
                        <Group className="groupsPaid" mode="plain">
                            <div style={{ paddingTop: 10, textAlign: "center" }}>
                                <Text weight="1">Добро пожаловать в <b>GiveMePublic!</b></Text>
                            </div>
                            <div className="quantityGroups">
                                <p style={{ color: "#f8f8f8", marginTop: "0px", textAlign: "center", fontSize: "18px" }}>Вам доступно</p>
                                <div className="groupsControls">
                                    <span style={{ color: baseTheme.colorAccentBlue.normal }}
                                    >30</span>
                                </div>
                                <p style={{ color: "#f8f8f8", marginTop: "0px", textAlign: "center", fontSize: "18px" }}>Пробных постов для использования</p>
                            </div>
                            <div className="payGroupsFooter">
                                <Button className="addChannel"
                                    style={{ color: baseTheme.colorTextContrast.normal, backgroundColor: baseTheme.colorAccentBlue.normal, height: "52px", marginBottom: "6px" }}
                                    size='s'
                                    stretched='true'
                                    onClick={() => {
                                        axios.post('https://api.gmpapp.ru/post_pay', {
                                            userId: window.Telegram.WebApp.initDataUnsafe.user.id,
                                            paid: true
                                        })
                                            .then(response => {
                                                setActiveView('home');
                                                tg.openTelegramLink('https://t.me/GiveMePublicBot?startchannel&admin=post_messages+edit_messages+restrict_members+pin_messages+manage_chat+delete_messages');
                                            })
                                            .catch(error => {
                                                console.log('Ошибка POST-запроса:', error);
                                            });
                                    }}
                                >
                                    Добавить канал
                                </Button>
                            </div>
                        </Group>
                    </div>
                </Panel>
            </View> */}
            {/* <View onSwipeBack activePanel="panel5.1" id="payment">
                <Panel id="panel5.1">
                    <PayPage cashlessPsc={cashlessPsc} setCashlessPsc={setCashlessPsc} cashlessPdf={cashlessPdf} setCashlessPdf={setCashlessPdf} openError={openError} activeView={activeView} setActiveView={setActiveView} userInfo={userInfo} snackbar={snackbar} postsBalance={postsBalance} isMobile={isMobile} />
                </Panel>
            </View> */}
            <View activePanel="panel10.1" id="premode">
                <Panel id="panel10.1" className="premodePanel">
                    <PremodePage setSelectedPostText={setSelectedPostText} setSelectedPremodePost={setSelectedPremodePost} selectedGroup={selectedGroup} premodePosts={premodePosts} loadingScreen={loadingScreen} setLoadingScreen={setLoadingScreen} openError={openError} activeView={activeView} setActiveView={setActiveView} snackbar={snackbar} setPremodePosts={setPremodePosts} isMobile={isMobile} />
                </Panel>
            </View>
            <View activePanel="panel13.1" id="posteditor">
                <Panel id="panel13.1">
                    <Group className="paymentView" style={{ textAlign: "left" }}>
                        <PostPage isMobile={isMobile} selectedPremodePost={selectedPremodePost} selectedGroup={selectedGroup} activeView={activeView} setActiveView={setActiveView} showAlert={tg.showAlert} avatarSrc={avatarSrc} premodePosts={premodePosts} setPremodePosts={setPremodePosts} />
                    </Group>
                </Panel>
            </View>
            <View activePanel="panel15.1" id="pusheditor">
                <Panel id="panel15.1">
                    <PanelHeader
                        before={
                            <PanelHeaderBack
                                onClick={() => {
                                    tg.showPopup({
                                        title: "Выйти без сохранения",
                                        message: "Вы действительно хотите выйти? Все несохранённые данные будут потеряны",
                                        buttons: [
                                            { id: 'back', type: 'destructive', text: 'Выйти' },
                                            { id: 'cancel', type: 'cancel' },
                                        ]
                                    }, (buttonId) => {
                                        if (buttonId === 'cancel') {
                                            console.log("Действие отменено");
                                        } else if (buttonId === 'back') {
                                            setActiveView('view1');
                                        }
                                    });
                                }}
                                label={platform === Platform.VKCOM ? 'Назад' : undefined}
                            />
                        }
                    >Пуши</PanelHeader>

                    <Group className="paymentView" style={{ textAlign: "left" }}>
                        <Push setActiveView={setActiveView} showAlert={tg.showAlert} />
                    </Group>
                </Panel>
            </View>
            <View activePanel="panel14.1" id="testgpt">
                <Panel id="panel14.1">
                    <Group className="testGptView" style={{ textAlign: "left", background: backgroundStyle, minHeight: "90vh" }}>
                        <TestGPT activeView={activeView} setActiveView={setActiveView} gptLink={gptLink} gptMedia={gptMedia} gptText={gptText} selectedGroup={selectedGroup} avatarSrc={avatarSrc} />
                    </Group>
                </Panel>
            </View>
            <View activePanel="paysuccess" id="paysuccess">
                <Panel id="paysuccess">
                    <Group style={{ textAlign: "center" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="150" height="150" viewBox="0 0 48 48">
                            <path fill="#c8e6c9" d="M44,24c0,11-9,20-20,20S4,35,4,24S13,4,24,4S44,13,44,24z"></path><polyline fill="none" stroke="#4caf50" stroke-miterlimit="10" stroke-width="4" points="14,24 21,31 36,16"></polyline>
                        </svg>
                        <Text weight="1" style={{ paddingTop: "10px" }}>Счёт успешно сформирован!</Text>
                        <Text style={{ paddingTop: "10px" }}>После проведение платежа вам будут начислены:</Text>
                        <Text weight="2" style={{ paddingTop: "10px" }}>{cashlessPsc} постов</Text>
                        <Text style={{ paddingTop: "10px" }}>Счёт на оплату в формате PDF вы можете скачать по кнопке ниже или позже на странице «Оплата»</Text>
                        <Button
                            style={{
                                fontFamily: "VK Sans Display",
                                width: "100%",
                                fontSize: "14px",
                                fontWeight: "500",
                                border: "none",
                                borderRadius: "10px",
                                height: "52px",
                                marginBottom: "6px",
                                marginTop: "30px"
                            }}
                            onClick={() => window.open(cashlessPdf)}
                            appearance="negative" after={<Icon16DownloadOutline />}>
                            Скачать PDF
                        </Button>
                    </Group>
                </Panel>
            </View>
        </Root>
    );
};

export default Home;
